export default "__VITE_ASSET__DhUiQwiQ__"